/**
 * Validation types for period charge validation errors.
 * Used to identify specific types of mismatches between CLI and JE Tag sums.
 */
export enum PeriodChargeValidationType {
    YTD_BASE_SUM_MISMATCH = 'YTD_BASE_SUM_MISMATCH',
    YTD_TOTAL_SUM_MISMATCH = 'YTD_TOTAL_SUM_MISMATCH'
}

export interface PeriodChargeValidationError {
    errorMessage: string;
    validationType: PeriodChargeValidationType;
}

/**
 * Contains the overall validation result for period charges, including validation status
 * and any specific errors found during validation of CLI vs JE Tag sum comparisons.
 */
export default interface PeriodChargeValidationResult {
    isValid: boolean;
    validationErrors: PeriodChargeValidationError[];
}